// AUTO-GENERATED at build by scripts/generate-legal-identity.mjs — DO NOT EDIT.
// Single source of truth: canonical backend COMPANY_* (boot-validated). Bank IBAN/BIC excluded.
export const COMPANY_LEGAL = {
  "brand": "Black Matte",
  "legalName": "BACHLAM",
  "legalForm": "SASU",
  "shareCapital": "500 EUR",
  "siren": "953195724",
  "siret": "95319572400018",
  "vat": "FR24953195724",
  "rcs": "RCS Nantes 953195724",
  "apeNaf": "4932Z",
  "address": {
    "street": "6 rue Antoine de Saint-Exupéry",
    "postalCode": "44300",
    "city": "Nantes",
    "country": "France"
  },
  "phone": "09 39 24 23 20",
  "email": "contact@blackmatte.fr",
  "directorOfPublication": "Anzor Musaev, Président de BACHLAM SASU",
  "host": {
    "name": "Hetzner Online GmbH",
    "street": "Industriestr. 25",
    "postalCode": "91710",
    "city": "Gunzenhausen",
    "country": "Germany"
  }
};

export default COMPANY_LEGAL;
